import React from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

// === Card Icons ===
import PeopleIcon from "@mui/icons-material/People";
import BarChartIcon from "@mui/icons-material/BarChart";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import InventoryIcon from "@mui/icons-material/Inventory";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";

// ==== Card Colors (same as original) ====
// ==== Card Colors (aligned to cardData sequence) ====
const cardColors = [
  "#9b59b6", // Accounts Dashboard - purple
  "#3498db", // General Vouchers - light blue
  "#7ed321", // Purchase Vouchers - light green
  "#c4b5f6", // Payments (Proforma Invoice) - Lavender Blue
  "#2ecc71", // Reports - green
  "#e74c3c", // Approved Transactions - red
  "#f39c12", // Pending Approvals - orange
  "#34495e", // Audit Logs - dark blue
];




// ==== Card Data for Accounts Page ====
const cardData = [
  { title: "Journal Vouchers", icon: <TrendingUpIcon sx={{ fontSize: 30 }} /> },
  { title: "Purchase Vouchers", icon: <ShoppingCartIcon sx={{ fontSize: 28 }} /> },
  { title: "Payments Vouchers", icon: <ReceiptLongIcon sx={{ fontSize: 28 }} /> },
  { title: "Sale Vouchers", icon: <InventoryIcon sx={{ fontSize: 30 }} /> },
  { title: "Recipt Vouchers", icon: <InventoryIcon sx={{ fontSize: 30 }} /> },
];

// ==== Dummy Table Data ====
const tableData = Array.from({ length: 10 }, (_, i) => ({
  voucher_no: `ACV${String(i + 1).padStart(3, "0")}`,
  voucher_type: i % 2 === 0 ? "General" : "Purchase",
  created_by: `User ${i + 1}`,
  status: i % 3 === 0 ? "Approved" : "Pending",
  amount: `$${(i + 1) * 100}`,
  created_at: `2025-08-${(i % 28) + 1}`,
}));

// Helper function to calculate counts for each card
const getCardCounts = (title) => {
  let filtered = [];

  switch (title) {
    case "Journal Vouchers":
      filtered = tableData.filter((row) => row.voucher_type === "General");
      break;
    case "Purchase Vouchers":
      filtered = tableData.filter((row) => row.voucher_type === "Purchase");
      break;
    case "Payments Vouchers":
      filtered = tableData.filter((row) => row.voucher_type === "Payments");
      break;
    case "Sale Vouchers":
      filtered = tableData.filter((row) => row.voucher_type === "Sale");
      break;
    case "Recipt Vouchers":
      filtered = tableData.filter((row) => row.voucher_type === "Recipt");
      break;
    default:
      filtered = tableData;
  }

  const total = filtered.length;
  const pending = filtered.filter((row) => row.status === "Pending").length;
  const approved = filtered.filter((row) => row.status === "Approved").length;

  return { total, pending, approved };
};


export default function AccountsDashboard() {
  return (
    <div style={{ padding: "20px" }}>
      {/* ==== CARDS ==== */}
      <Grid container spacing={2} sx={{ mt: -3, mb: 2 }}>
        {/* {cardData.map((card, index) => ( */}
        {cardData.map((card, index) => {
          const counts = getCardCounts(card.title); // calculate counts for each card

          return (
            <Grid item xs={12} sm={6} md={2.4} key={index} sx={{ mt: -4, mb: 4 }}>
              <Card
                sx={{
                  height: 120,
                  borderRadius: 0,
                  background: cardColors[index],
                  color: "white",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  p: 1,

                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-5px)",

                  },
                }}
              >
                <div>{card.icon}</div>
                <CardContent sx={{ p: 0 }}>
                  <Typography variant="subtitle1" fontWeight="bold" sx={{ fontSize: { xs: "10px", sm: "12px", md: "15px" } }} noWrap>
                    {card.title}
                  </Typography>
                  
                  <Typography variant="caption" display="block">
                    Total: {counts.total} <br />
                    Pending: {counts.pending} <br />
                    Approved: {counts.approved}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          );
          // ))}
        })}
      </Grid>

      {/* ==== Pending Accounts Table ==== */}
      <TableContainer
        component={Paper}
        sx={{ borderRadius: 0, boxShadow: 2, maxHeight: 500, overflowY: "auto" }}
      >
        <Typography
          variant="h6"
          fontWeight="bold"
          sx={{
            p: 2,
            bgcolor: "#f5f5f5",
            color: "#333",
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
            borderBottom: "1px solid #ccc",
          }}
        >
          Pending Accounts Vouchers
        </Typography>

        <Table
          size="small"
          stickyHeader
          sx={{
            width: "100%",
            "& th, & td": {
              borderBottom: "1px solid #ccc",
              textAlign: "center",
              paddingTop: '2px !important',
              paddingBottom: '2px !important',
              fontSize: { xs: "0.75rem", sm: "0.8125rem" }, // responsive font
              whiteSpace: "nowrap",
              padding: "4px 6px",
            },
            "& th": {
              backgroundColor: "#f5f5f5",
              fontWeight: "bold",
              color: "#333",
              padding: "4px 6px",
            },
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell>Sl. No.</TableCell>
              <TableCell>Voucher No.</TableCell>
              <TableCell>Voucher Type</TableCell>
              <TableCell>Created By</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Amount</TableCell>
              <TableCell>Created Date</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData.map((row, index) => (
              <TableRow
                key={index}
                hover
                sx={{
                  backgroundColor: index % 2 === 0 ? "#ffffff" : "#f7f7f7",
                  "&:hover": { backgroundColor: "#e3f2fd", cursor: "pointer" },
                }}
              >
                <TableCell>{index + 1}</TableCell>
                <TableCell>{row.voucher_no || "-"}</TableCell>
                <TableCell>{row.voucher_type || "-"}</TableCell>
                <TableCell>{row.created_by || "-"}</TableCell>
                <TableCell>{row.status || "-"}</TableCell>
                <TableCell>{row.amount || "-"}</TableCell>
                <TableCell>
                  {row.created_at
                    ? new Date(row.created_at).toLocaleDateString()
                    : "-"}
                </TableCell>
              </TableRow>
            ))}
            {tableData.length === 0 && (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  No Records Found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
